import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {Views} from '@ccp/config/views';
import {InitializationService} from '@ccp/services/app-context/initialization.service';

export const ProductRegisterGuard: CanActivateFn = () => {
  const router = inject(Router);
  const initializationService = inject(InitializationService);
  return initializationService.isReady$() ? true : router.createUrlTree([Views.retryPage.path]);
};
